import React  from 'react';
import Base from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import withPreload from "./Preload";


const Autocomplete = withPreload((props) =>{
  let { valid, error, input, renderInput: rInput } = props;
  let { classes, renderOption, inputProps, InputProps, controlProps } = props;

  function renderMap(params){

    if(!params?.InputProps?.startAdornment){
      delete params?.InputProps?.startAdornment
    }
    if(!params?.InputProps?.endAdornment){
      delete params?.InputProps?.endAdornment
    }

    InputProps = Object.assign(InputProps, params?.InputProps)
    inputProps = Object.assign(inputProps, params?.inputProps, { autoComplete: 'disabled' })

    params = Object.assign(params, controlProps, { InputProps, inputProps });
    return params;
  }

  let renderInput = (function (params){
    return (<TextField {...renderMap(params)} />)
  });

  if(!!rInput){
    renderInput = (function (params) {
      return rInput(renderMap(params))
    });
  }

  return (<Base
    {...{
      ...input, classes, error: !valid, helpertext: error ?  error: null, renderInput,
      renderOption: renderOption || (({ label, value }) => (<>{label} ({value})</>)),
    }}
  />)
})


Autocomplete.defaultProps = {
  meta: {},
  freeSolo: true,
  variant: 'outlined',
  margin: 'normal',
  fullWidth: true,
  required: false,
  type: 'text',
  autoComplete:'off',
  size:'small'
};

export default Autocomplete;


